import { UserRoles } from '@anytag/graphql';
import { Form } from '@anytag/shared-atoms';
import { UserLinkedFormSchema } from './schema';
import { Template } from './Template';
import { UserLinkedFormProps } from './types';

export const UserLinkedForm = ({ onSubmit, defaultValues }: UserLinkedFormProps) => (
  <Form.Provider
    onSubmit={onSubmit}
    zodSchema={UserLinkedFormSchema}
    defaultValues={{
      advertiserId: defaultValues?.advertiserId || '',
      userType: defaultValues?.userType || UserRoles.STAFF,
      staffIds: [],
      countryId: ''
    }}
  >
    <Template />
  </Form.Provider>
);

export * from './types';
